import { local } from './constants';

// Single source of truth for Stripe price IDs.
// Any change here must be the only change needed across pricing page,
// post-login checkout redirect, and dashboard upgrade flows.
//
// MAINTENANCE: to change a plan's price, create a NEW price under the EXISTING
// Stripe product and paste its id here — do NOT create a new product. Prices are
// immutable in Stripe; products are stable. (Keeps webhook product-name -> tier
// mapping and reporting intact.)
// Lifetime is a one-off (non-recurring) Stripe price. It has no monthly/yearly
// split — `oneTime` is the single id, and the resolver below falls back to it
// for any requested billing cycle so callers don't need a special case.
//
// Unlimited Yearly is yearly-only: both keys point at the same $1,250/yr price so
// any caller that passes the page's billing toggle still resolves it.
//
// TODO(new-unlimited-prices): replace the REPLACE_ME ids with the new Stripe
// prices — Unlimited Yearly ($1,250/yr, product "Sixth Unlimited") and Lifetime
// ($1,750 one-time, a NEW price on the existing "Sixth Lifetime Plan" product).
const UNLIMITED_YEARLY_TEST = 'price_REPLACE_ME_unlimited_yearly_test';
const UNLIMITED_YEARLY_LIVE = 'price_1UKibOHHcvRSE91FQD5OiawD';
const LIFETIME_1750_TEST = 'price_REPLACE_ME_lifetime_1750_test';
const LIFETIME_1750_LIVE = 'price_1UKiaPHHcvRSE91FLum1toT5';

export const PRICE_IDS = {
  test: {
    'Pro':      { monthly: 'price_1TopZtHtq0wFv4C17vh4kjoA', yearly: 'price_1TDAJFHtq0wFv4C1xN8srHzM' },
    'Pro+':     { monthly: 'price_1TDAJoHtq0wFv4C1D2D2u8Zs', yearly: 'price_1TDAKPHtq0wFv4C1tKGWXKZL' },
    'Ultra':    { monthly: 'price_1TDAOVHtq0wFv4C1TKnbnxKG', yearly: 'price_1TDAP9Htq0wFv4C13XIr1xCA' },
    'Unlimited': { monthly: UNLIMITED_YEARLY_TEST, yearly: UNLIMITED_YEARLY_TEST },
    'Lifetime': { oneTime: LIFETIME_1750_TEST }
  },
  live: {
    'Pro':      { monthly: 'price_1RybSDHHcvRSE91FVP3svcJm', yearly: 'price_1SblYHHHcvRSE91FZ7r7vhJj' },
    'Pro+':     { monthly: 'price_1TEphYHHcvRSE91F3u6oZhnx', yearly: 'price_1TEqGaHHcvRSE91FAJabXVNY' },
    'Ultra':    { monthly: 'price_1TEpiJHHcvRSE91FGTXjGbVD', yearly: 'price_1TEqG8HHcvRSE91FcaFddcwJ' },
    'Unlimited': { monthly: UNLIMITED_YEARLY_LIVE, yearly: UNLIMITED_YEARLY_LIVE },
    'Lifetime': { oneTime: LIFETIME_1750_LIVE }
  }
};

export const stripeMode = local ? 'test' : 'live';

// Resolve a price id by plan + billing cycle. For one-off plans (Lifetime) the
// `oneTime` id is returned regardless of the requested billing cycle.
export const getPriceId = (planName, billing) => {
  const plan = PRICE_IDS[stripeMode]?.[planName];
  if (!plan) return null;
  return plan[billing] || plan.oneTime || null;
};

export const SUPPORTED_PLANS = ['Pro', 'Pro+', 'Ultra', 'Unlimited', 'Lifetime'];
